import {Platform} from 'react-native';
import {
  customResponsiveHeight,
  customResponsiveFont,
  customResponsiveWidth,
} from '../utils/CustomResponsive';

enum FontWeight {
  Thin = 100,
  ExtraLight = 200,
  Light = 300,
  Regular = 400,
  Medium = 500,
  SemiBold = 600,
  Bold = 700,
  ExtraBold = 800,
}

export const styles = {
  //----------------------------------------font style
  font: {
    IranYekan: {
      [FontWeight.Light]:
        Platform.OS === 'ios' ? 'IRANYekanFN-Light' : 'IRANYekanThin',
      [FontWeight.Regular]: Platform.OS === 'ios' ? 'IRANYekanFN' : 'IRANYekan',
      [FontWeight.Medium]:
        Platform.OS === 'ios' ? 'IRANYekanFN-Medium' : 'IRANYekanMedium',
      [FontWeight.SemiBold]:
        Platform.OS === 'ios' ? 'IRANYekanFN-ExtraBold' : 'IRANYekanBold',
      [FontWeight.Bold]:
        Platform.OS === 'ios' ? 'IRANYekanFN-ExtraBold' : 'IRANYekanBold',
    },

    h1: customResponsiveFont(2.8),
    h2: customResponsiveFont(2.4),
    h3: customResponsiveFont(2),
    h4: customResponsiveFont(1.8),
    h5: customResponsiveFont(1.6),
    h6: customResponsiveFont(1.4),

    line_height: customResponsiveFont(3.4),
  },
  //----------------------------------------common sizes
  size: {
    horizontal_1: customResponsiveWidth(8),
    horizontal_2: customResponsiveWidth(6),
    horizontal_3: customResponsiveWidth(4),
    horizontal_4: customResponsiveWidth(2),
    horizontal_5: customResponsiveWidth(12),

    vertical_1: customResponsiveHeight(4),
    vertical_2: customResponsiveHeight(3),
    vertical_3: customResponsiveHeight(2),
    vertical_4: customResponsiveHeight(1),
    vertical_5: customResponsiveHeight(0.5),
    vertical_bottom: customResponsiveHeight(4),

    icon_1: customResponsiveHeight(3.6),
    icon_2: customResponsiveHeight(2.8),
    icon_3: customResponsiveHeight(4.6),
    icon_4: customResponsiveHeight(2),

    line: customResponsiveHeight(0.2),

    header_large: customResponsiveHeight(10),
    header_small: customResponsiveHeight(8),

    bottom_tab: customResponsiveHeight(10),

    border_1: customResponsiveHeight(2),
    border_2: customResponsiveHeight(1),
    border_3: customResponsiveHeight(0.2),
    border_4: customResponsiveHeight(3),
    border_5: customResponsiveHeight(3.5),
    border_close: customResponsiveHeight(2.7),

    input_1: customResponsiveHeight(8.5),
    input_2: customResponsiveHeight(7.5),
    input_3: customResponsiveHeight(6.5),

    input_multi_line: customResponsiveHeight(21),

    button_1: customResponsiveHeight(8),
    button_2: customResponsiveHeight(7),
    button_3: customResponsiveHeight(6),

    fab: customResponsiveHeight(7),
    close: customResponsiveHeight(6),

    active_opacity: 0.7,

    elevation_1: customResponsiveHeight(0.2),
    elevation_2: customResponsiveHeight(1),
    elevation_3: customResponsiveHeight(2),

    icon_button_margin_padding: customResponsiveHeight(1),

    indicator_1: customResponsiveHeight(2.6),

    first_item_position_1: customResponsiveHeight(24),
    first_item_position_2: customResponsiveHeight(20),

    circle_1: customResponsiveHeight(7),

    fix_input: customResponsiveHeight(0.6),

    modal_background_opacity: 0.3,
    modal_max_height: customResponsiveHeight(80),
    modal_width: customResponsiveWidth(80),
  },
};
